import { jsx as _jsx } from "react/jsx-runtime";
import { Select as RadixSelect } from '@radix-ui/themes';
import { forwardRef } from 'react';
import { withMappingProps } from '../../utils/radix.js';
const SelectRoot = RadixSelect.Root;
const SelectTrigger = withMappingProps(RadixSelect.Trigger);
const SelectContentBase = forwardRef((props, ref) => (_jsx(RadixSelect.Content, { ref: ref, position: "popper", side: "bottom", ...props })));
SelectContentBase.displayName = 'SelectContentBase';
const SelectContent = withMappingProps(SelectContentBase);
const SelectItem = RadixSelect.Item;
const SelectGroup = RadixSelect.Group;
const SelectLabel = RadixSelect.Label;
const SelectSeparator = RadixSelect.Separator;
export { SelectContent as Content, SelectGroup as Group, SelectItem as Item, SelectLabel as Label, SelectRoot as Root, SelectSeparator as Separator, SelectTrigger as Trigger, };
//# sourceMappingURL=select.js.map